import { useState } from 'react';
import { EXAMPLE } from '../data/imagine-copy';

/**
 * The whole exercise as one sum, shown before a photo is asked for
 * (well/product/33 §3): a photo of you + a place = you, drawn, in that place.
 *
 *   [snapshot]  +  [postcard]  =  [the drawing]
 *   Your photo     Your place     Your first creation
 *
 * The result is the biggest thing on the row: it is the promise. The picture
 * does the explaining, so the words can stay "drawn" (the first screens never
 * say AI, intro-copy.ts BANNED_WORDS).
 *
 * The photo is the owner's own selfie, published with his go-ahead
 * (2026-10-14). The result is the crew's real drawing of him in
 * `EXAMPLE.place`, made by the live pipeline from that selfie, so the postcard
 * names the place the picture shows. Should a file ever go missing, that slot
 * shows a dashed placeholder saying what belongs there instead of a broken
 * image.
 */
export function PhotoToDrawing({ idea = false }: { idea?: boolean }) {
  const [photo, setPhoto] = useState(true);
  const [result, setResult] = useState(true);
  return (
    <div className="p2d-wrap">
      <span className="label p2d-kicker">{EXAMPLE.kicker}</span>
      {/* with an idea from the intro (`idea_step`), the middle term is "Your idea": the same postcard, read as one */}
      <figure className="p2d" aria-label={idea ? EXAMPLE.ideaSaid : EXAMPLE.said}>
        <div className="p2d-term p2d-photo">
          <div className="p2d-frame">
            {photo
              ? <img src={EXAMPLE.photo} alt="" onError={() => setPhoto(false)} draggable={false} />
              : <span className="p2d-placeholder" data-placeholder="example-photo">Photo</span>}
          </div>
          <figcaption>{EXAMPLE.photoLabel}</figcaption>
        </div>
        <span className="p2d-op" aria-hidden="true">+</span>
        <div className="p2d-term p2d-place">
          <div className="p2d-frame">
            <span className="p2d-stamp" aria-hidden="true" />
            <span className="p2d-place-words">{EXAMPLE.place}</span>
          </div>
          <figcaption>{idea ? EXAMPLE.ideaLabel : EXAMPLE.placeLabel}</figcaption>
        </div>
        <span className="p2d-op" aria-hidden="true">=</span>
        <div className="p2d-term p2d-result">
          <div className="p2d-frame">
            {result
              ? <img src={EXAMPLE.result} alt="" onError={() => setResult(false)} draggable={false} />
              : <span className="p2d-placeholder" data-placeholder="example-result">Drawing</span>}
          </div>
          <figcaption>{EXAMPLE.resultLabel}</figcaption>
        </div>
      </figure>
    </div>
  );
}
